import { HiChevronDoubleRight } from "react-icons/hi2";

export const DoubleArrowIcon = ({ width, height, color, ...props }) => (
  <HiChevronDoubleRight
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
